document.addEventListener("DOMContentLoaded", function() {
  var images = document.querySelectorAll(".imageElement");

  images.forEach(function(img) {
    img.onerror = function() {
      img.parentNode.style.display = 'none';
    };

    img.onload = function() {
      if (!img.complete || img.naturalWidth === 0) {
        img.parentNode.style.display = 'none';
      }
    };

    // Trigger the error event if the image fails to load
    if (img.complete && img.naturalWidth === 0) {
      img.onerror();
    }
  });
});

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);


async function seachAddress() {
    await new Promise(resolve => setTimeout(resolve, 1000))
    var t_link = document.querySelector('#js_search_address a');
    if(t_link){
      const API_URL = "https://zipcloud.ibsnet.co.jp/api/search?zipcode=";

      const format = {
        zip1: /^\d{3}-?\d{4}$/, // 郵便番号(ハイフン有り)
        zip2: /^0\d{7}$/, // 郵便番号(ハイフン無し)
      };
      const zip = document.getElementById("43995-text-8")

      t_link.addEventListener('click', function(e) {
          if (zip.value != "") {
            // 郵便番号の形式か確認
            if (format.zip1.test(zip.value) || format.zip2.test(zip.value)) {
              const url = API_URL + zip.value;
              fetch(url)
                .then((data) => {
                  return data.json();
                })
                .then((data) => {
                  if (data.results != null) {
                    var pref_form = document.getElementById("43995-select-1");
                    for(const option of pref_form.options) {
                      if(option.value === data.results[0].address1) option.selected = true;
                    };
                    var city01_form = document.getElementById("43995-text-4");
                    city01_form.value = data.results[0].address2;
                    var city02_form = document.getElementById("43995-text-5");
                    city02_form.value = data.results[0].address3;
                  } else {
                    alert("該当する住所が見つかりませんでした。");
                  }
                })
                .catch((error) => {
                  alert("住所検索に失敗しました。");
                });

            } else {
              alert("郵便番号の形式で入力してください。");
            }
          } else {
            alert("郵便番号を入力してください。");
          }
          
        }, false);
    }
  }
  seachAddress()
